import { render, staticRenderFns } from "./AffSubBlacklist.vue?vue&type=template&id=e573c624&scoped=true"
import script from "./AffSubBlacklist.vue?vue&type=script&lang=js"
export * from "./AffSubBlacklist.vue?vue&type=script&lang=js"
import style0 from "./AffSubBlacklist.vue?vue&type=style&index=0&id=e573c624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e573c624",
  null
  
)

export default component.exports